import React, { useState, useEffect } from 'react';
import axios from 'axios'; // <-- tambahin ini
import { API_URL } from '../utils/api';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  TextField,
  InputAdornment,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  Avatar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  Tooltip,
  Fade,
  CircularProgress,
  TablePagination,
  ToggleButton,
  ToggleButtonGroup,
} from '@mui/material';
import {
  Search,
  FilterList,
  AccessTime,
  CheckCircle,
  Error,
  Warning,
  Person,
  Description,
  Print,
  Close,
  Delete,
  Add,
  LocalHospital,
  EventNote,
} from '@mui/icons-material';
import StatusChangeModal from '../components/StatusChangeModal';

const Attendance = () => {
  const [attendanceData, setAttendanceData] = useState([]);
  const [totalStudents, setTotalStudents] = useState(0);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  const [filterGrade, setFilterGrade] = useState('all');
  const [filterRange, setFilterRange] = useState('date');
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);
  const [selectedMonth, setSelectedMonth] = useState(new Date().toISOString().slice(0, 7));
  const [openDetailsDialog, setOpenDetailsDialog] = useState(false);
  const [selectedAttendance, setSelectedAttendance] = useState(null);
  const [printPreview, setPrintPreview] = useState({ open: false, content: '' });
  const [deletingId, setDeletingId] = useState(null);
  const [deleteConfirm, setDeleteConfirm] = useState({ open: false, attendance: null });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [personTab, setPersonTab] = useState('student');
  const [peopleList, setPeopleList] = useState([]);
  const [openManualDialog, setOpenManualDialog] = useState(false);
  const [manualSubmitting, setManualSubmitting] = useState(false);
  const [manualForm, setManualForm] = useState({
    employee_id: '',
    date: new Date().toISOString().split('T')[0],
    status: 'permission',
    notes: '',
  });
   const [manualSearch, setManualSearch] = useState('');
   const [manualError, setManualError] = useState('');
   const [statusChangeDialog, setStatusChangeDialog] = useState({ open: false, attendance: null, newStatus: '' });
   const [statusChangeLoading, setStatusChangeLoading] = useState(false);
   const [statusChangeError, setStatusChangeError] = useState('');
   const [statusModalOpen, setStatusModalOpen] = useState(false);
   const [selectedAttendanceForStatus, setSelectedAttendanceForStatus] = useState(null);
   const [successDialogOpen, setSuccessDialogOpen] = useState(false);

  const MANUAL_STATUSES = ['sick', 'permission'];
  const isManualStatus = (status) => MANUAL_STATUSES.includes(status);

  const grades = [1, 2, 3, 4, 5, 6];
  const isTeacherTab = personTab === 'teacher';

  const localDateKey = (value) => {
    if (!value) return '';
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return '';
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  };

  const calculateWorkingDuration = (checkIn, checkOut) => {
    if (!checkIn || !checkOut) return { seconds: 0, hours: 0 };
    const start = new Date(checkIn);
    const end = new Date(checkOut);
    if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) return { seconds: 0, hours: 0 };
    const diffMs = end.getTime() - start.getTime();
    if (diffMs <= 0) return { seconds: 0, hours: 0 };
    const seconds = Math.floor(diffMs / 1000);
    const hours = parseFloat((diffMs / (1000 * 60 * 60)).toFixed(2));
    return { seconds, hours };
  };

  /** Urutan rombel: B → A → C (6B, 6A, 5B, 5A, … 3C, 3B, 3A). */
  const rombelSortRank = (classroom) => {
    const order = { B: 0, A: 1, C: 2 };
    return order[String(classroom || '').trim().toUpperCase()] ?? 99;
  };

  /** Siswa per tanggal: sudah scan di atas; urut kelas tinggi + rombel B→A→C; dalam rombel sama jam terbaru dulu. */
  const sortStudentAttendanceRows = (rows) => [...rows].sort((a, b) => {
    const aHas = a.checkIn ? 1 : 0;
    const bHas = b.checkIn ? 1 : 0;
    if (aHas !== bHas) return bHas - aHas;

    const ga = Number(a.grade) || 0;
    const gb = Number(b.grade) || 0;
    if (ga !== gb) return gb - ga;

    const rombelDiff = rombelSortRank(a.classroom) - rombelSortRank(b.classroom);
    if (rombelDiff !== 0) return rombelDiff;

    if (aHas && bHas) {
      return new Date(b.checkIn).getTime() - new Date(a.checkIn).getTime();
    }
    return (Number(b.personDbId) || 0) - (Number(a.personDbId) || 0);
  });

  const sortByLatestCheckIn = (rows) => [...rows].sort((a, b) => {
    const ta = a.checkIn ? new Date(a.checkIn).getTime() : 0;
    const tb = b.checkIn ? new Date(b.checkIn).getTime() : 0;
    if (ta && tb) return tb - ta;
    if (ta) return -1;
    if (tb) return 1;
    return (a.name || '').localeCompare(b.name || '', 'id');
  });

  const mapPersonDayRow = (person, attendance, dateKey, forTeacher = false) => {
    if (!attendance?.check_in) {
      return {
        id: `absent-${person.id}-${dateKey}`,
        personDbId: person.id,
        name: person.full_name,
        studentId: person.student_id,
        grade: forTeacher ? null : person.grade,
        classroom: forTeacher ? 'Guru' : person.classroom,
        checkIn: null,
        checkOut: null,
        status: 'absent',
        notes: '',
        isManual: false,
        avatar: person.full_name ? person.full_name[0].toUpperCase() : '?',
        totalHours: 0,
        totalDurationSeconds: 0,
        overtime: 0,
        date: dateKey,
        hasRecord: false,
      };
    }
    const duration = calculateWorkingDuration(attendance.check_in, attendance.check_out);
    const status = attendance.status || 'present';
    return {
      id: attendance.id,
      personDbId: person.id,
      name: person.full_name,
      studentId: person.student_id,
      grade: forTeacher ? null : person.grade,
      classroom: forTeacher ? 'Guru' : person.classroom,
      checkIn: attendance.check_in,
      checkOut: attendance.check_out,
      status,
      notes: attendance.notes || '',
      isManual: isManualStatus(status),
      avatar: person.full_name ? person.full_name[0].toUpperCase() : '?',
      totalHours: duration.hours,
      totalDurationSeconds: attendance.check_out ? duration.seconds : 0,
      overtime: duration.hours > 8 ? parseFloat((duration.hours - 8).toFixed(2)) : 0,
      date: dateKey,
      hasRecord: true,
    };
  };

  const mapRecordRow = (item, forTeacher = false) => {
    const duration = calculateWorkingDuration(item.check_in, item.check_out);
    const dateKey = localDateKey(item.check_in);
    const status = item.status || 'present';
    return {
      id: item.id,
      name: item.full_name,
      studentId: item.student_id || String(item.employee_id),
      grade: forTeacher ? null : item.grade,
      classroom: forTeacher ? 'Guru' : item.classroom,
      checkIn: item.check_in,
      checkOut: item.check_out,
      status,
      notes: item.notes || '',
      isManual: isManualStatus(status),
      avatar: item.full_name ? item.full_name[0].toUpperCase() : '?',
      totalHours: duration.hours,
      totalDurationSeconds: item.check_out ? duration.seconds : 0,
      overtime: duration.hours > 8 ? parseFloat((duration.hours - 8).toFixed(2)) : 0,
      date: dateKey,
      hasRecord: true,
    };
  };

  useEffect(() => {
    loadAttendanceData();
    loadTotalPeople();
  }, [filterRange, selectedDate, selectedMonth, personTab]);

  const loadTotalPeople = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        console.warn('Token autentikasi tidak ditemukan');
        return;
      }

      const res = await axios.get(`${API_URL}/api/employees?person_type=${personTab}`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      const people = res.data.data || [];
      setTotalStudents(people.length);
      setPeopleList(people);
    } catch (error) {
      console.error('Error loading total people:', error);
    }
  };

  const loadAttendanceData = async () => {
    try {
      setLoading(true);

      const token = localStorage.getItem('token');
      if (!token) {
        console.warn('Token autentikasi tidak ditemukan');
        return;
      }

      const peopleRes = await axios.get(`${API_URL}/api/employees?person_type=${personTab}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const allPeople = peopleRes.data.data || [];
      setPeopleList(allPeople);

      const params = { limit: 10000, page: 1, person_type: personTab };

      if (filterRange === 'date' && selectedDate?.trim()) {
        params.date = selectedDate.trim();
      } else if (filterRange === 'month' && selectedMonth?.trim()) {
        params.month = selectedMonth.trim();
      }

      const attRes = await axios.get(`${API_URL}/api/attendance`, {
        params,
        headers: { Authorization: `Bearer ${token}` }
      });

      const rawAttendance = attRes.data.data || [];
      let mappedData = [];

      if (filterRange === 'date' && selectedDate?.trim()) {
        const dateKey = selectedDate.trim();
        mappedData = allPeople.map((person) => {
          const dayRecords = rawAttendance
            .filter((a) => String(a.employee_id) === String(person.id)
              && localDateKey(a.check_in) === dateKey)
            .sort((a, b) => new Date(b.check_in) - new Date(a.check_in));
          const attendance = dayRecords[0] || null;
          return mapPersonDayRow(person, attendance, dateKey, isTeacherTab);
        });
        mappedData = isTeacherTab ? sortByLatestCheckIn(mappedData) : sortStudentAttendanceRows(mappedData);
      } else if (filterRange === 'month' && selectedMonth?.trim()) {
        mappedData = sortByLatestCheckIn(
          rawAttendance
            .filter((item) => localDateKey(item.check_in).slice(0, 7) === selectedMonth.trim())
            .map((item) => mapRecordRow(item, isTeacherTab))
        );
      } else {
        mappedData = sortByLatestCheckIn(rawAttendance.map((item) => mapRecordRow(item, isTeacherTab)));
      }

      setAttendanceData(mappedData);
      setPage(0);
    } catch (error) {
      console.error('Error loading attendance data:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleOpenDetails = (attendance) => {
    setSelectedAttendance(attendance);
    setOpenDetailsDialog(true);
  };

  const handleCloseDetails = () => {
    setOpenDetailsDialog(false);
    setSelectedAttendance(null);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'present': return '#10b981';
      case 'late': return '#f59e0b';
      case 'absent': return '#ef4444';
      case 'sick': return '#3b82f6';
      case 'permission': return '#8b5cf6';
      default: return '#6b7280';
    }
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case 'present': return 'Hadir';
      case 'late': return 'Terlambat';
      case 'absent': return 'Alpha';
      case 'sick': return 'Sakit';
      case 'permission': return 'Izin';
      default: return 'Unknown';
    }
  };

  const formatDuration = (seconds) => {
    if (!seconds || seconds <= 0) return '-';
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    const parts = [];
    parts.push(`${hrs} jam`);
    parts.push(`${mins} menit`);
    parts.push(`${secs} detik`);
    return parts.join(' ');
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'present': return <CheckCircle />;
      case 'late': return <Warning />;
      case 'absent': return <Error />;
      case 'sick': return <LocalHospital />;
      case 'permission': return <EventNote />;
      default: return <AccessTime />;
    }
  };

  const rangeFilteredAttendance = attendanceData;

  const filteredAttendance = rangeFilteredAttendance.filter(attendance => {
    const matchesSearch = attendance.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         attendance.studentId.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = filterStatus === 'all' || attendance.status === filterStatus;
    const matchesGrade = filterGrade === 'all' || attendance.grade?.toString() === filterGrade.toString();
    
    return matchesSearch && matchesStatus && matchesGrade;
  });

  const getStats = () => {
    const statsRows = rangeFilteredAttendance.filter((att) => {
      const matchesSearch = att.name?.toLowerCase().includes(searchTerm.toLowerCase())
        || att.studentId?.toLowerCase().includes(searchTerm.toLowerCase());
      const matchesGrade = filterGrade === 'all' || att.grade?.toString() === filterGrade.toString();
      return matchesSearch && matchesGrade;
    });

    if (filterRange === 'date' && selectedDate?.trim()) {
      const present = statsRows.filter((r) => r.status === 'present').length;
      const late = statsRows.filter((r) => r.status === 'late').length;
      const absent = statsRows.filter((r) => r.status === 'absent').length;
      const sick = statsRows.filter((r) => r.status === 'sick').length;
      const permission = statsRows.filter((r) => r.status === 'permission').length;
      return { total: totalStudents, present, late, absent, sick, permission };
    }

    const present = statsRows.filter((r) => r.status === 'present').length;
    const late = statsRows.filter((r) => r.status === 'late').length;
    const absent = statsRows.filter((r) => r.status === 'absent').length;
    const sick = statsRows.filter((r) => r.status === 'sick').length;
    const permission = statsRows.filter((r) => r.status === 'permission').length;
    return { total: statsRows.length || totalStudents, present, late, absent, sick, permission };
  };

  const stats = getStats();


  const buildPrintTemplate = (attendance) => {
    const formatDate = (value) => {
      if (!value) return '-';
      try {
        return new Date(value).toLocaleDateString('id-ID', {
          weekday: 'long',
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        });
      } catch (e) {
        return value;
      }
    };

    const formatTime = (value) => {
      if (!value) return 'Tidak Hadir';
      try {
        return new Date(value).toLocaleTimeString('id-ID', {
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        });
      } catch (e) {
        return value;
      }
    };

    const generatedAt = new Date().toLocaleString('id-ID');
    const totalJam = formatDuration(attendance.totalDurationSeconds);
    const lembur = attendance.overtime > 0 ? `${attendance.overtime} jam` : 'Tidak ada';

    return `<!DOCTYPE html>
    <html lang="id">
      <head>
        <meta charset="utf-8" />
        <title>Cetak Absensi</title>
        <style>
          * { box-sizing: border-box; }
          body {
            margin: 0;
            padding: 32px;
            background: #edf2ff;
            font-family: 'Segoe UI', Tahoma, sans-serif;
            color: #0f172a;
          }
          .container {
            max-width: 760px;
            margin: 0 auto;
            background: #ffffff;
            border-radius: 18px;
            box-shadow: 0 18px 42px rgba(15, 23, 42, 0.14);
            overflow: hidden;
          }
          .header {
            background: linear-gradient(135deg, #f3f4ff, #e3e9ff);
            padding: 30px 36px;
            display: flex;
            align-items: center;
            gap: 22px;
          }
          .header-icon {
            width: 84px;
            height: 84px;
            border-radius: 24px;
            background: #1d4ed8;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            font-size: 42px;
            box-shadow: 0 12px 28px rgba(29, 78, 216, 0.25);
          }
          .header-text h1 {
            margin: 0;
            font-size: 24px;
            letter-spacing: 1px;
            font-weight: 700;
            text-transform: uppercase;
          }
          .header-text span {
            display: inline-block;
            margin-top: 8px;
            padding: 6px 14px;
            border-radius: 999px;
            background: rgba(29, 78, 216, 0.1);
            color: #1d4ed8;
            font-size: 12px;
            font-weight: 600;
            text-transform: uppercase;
          }
          .body {
            padding: 32px 38px;
          }
          .section-title {
            font-size: 14px;
            font-weight: 700;
            text-transform: uppercase;
            color: #2563eb;
            margin-bottom: 12px;
            letter-spacing: 1px;
          }
          .section-desc {
            font-size: 13px;
            color: #64748b;
            margin-bottom: 22px;
          }
          table {
            width: 100%;
            border-collapse: collapse;
            border-radius: 14px;
            overflow: hidden;
            margin-bottom: 28px;
          }
          th, td {
            padding: 14px 18px;
            border-bottom: 1px solid #e2e8f0;
            font-size: 14px;
          }
          th {
            width: 33%;
            background: #f1f5f9;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 0.5px;
            color: #1e293b;
          }
          tr:last-child th, tr:last-child td {
            border-bottom: none;
          }
          .footer {
            display: flex;
            justify-content: space-between;
            font-size: 12px;
            color: #94a3b8;
            margin-top: 24px;
            padding-top: 16px;
            border-top: 1px dashed #d1d5db;
          }
          .signature {
            text-align: right;
            font-size: 13px;
            color: #475569;
            margin-top: 40px;
          }
          .signature span {
            display: inline-block;
            margin-top: 36px;
            border-top: 1px solid #cbd5f5;
            padding-top: 6px;
          }
          @media print {
            body {
              background: #ffffff;
              padding: 0;
            }
            .container {
              box-shadow: none;
              border-radius: 0;
            }
          }
        </style>
      </head>
      <body>
        <div class="container">
          <div class="header">
            <div class="header-icon">🕒</div>
            <div class="header-text">
              <h1>Detail Absensi Siswa</h1>
              <span>SD NEGERI [Ubah Nama Sekolah]</span>
            </div>
          </div>
          <div class="body">
            <div class="section-desc">
              Berikut adalah catatan kehadiran yang tersimpan pada sistem untuk siswa berikut:
            </div>
            <div class="section-title">Informasi Umum</div>
            <table>
              <tr><th>Nama Siswa</th><td>${attendance.name || '-'}</td></tr>
              <tr><th>NIS</th><td>${attendance.studentId || '-'}</td></tr>
              <tr><th>Kelas</th><td>${attendance.grade || '-'}</td></tr>
              <tr><th>Rombel</th><td>${attendance.classroom || '-'}</td></tr>
            </table>
            <div class="section-title">Detail Kehadiran</div>
            <table>
              <tr><th>Tanggal</th><td>${formatDate(attendance.checkIn)}</td></tr>
              <tr><th>Check In</th><td>${formatTime(attendance.checkIn)}</td></tr>
              <tr><th>Check Out</th><td>${formatTime(attendance.checkOut)}</td></tr>
              <tr><th>Status Kehadiran</th><td>${getStatusLabel(attendance.status)}</td></tr>
              <tr><th>Total Jam</th><td>${totalJam}</td></tr>
              <tr><th>Keterangan</th><td>${attendance.notes || '-'}</td></tr>
            </table>
            <div class="footer">
              <div>Dicetak pada: ${generatedAt}</div>
              <div>Lokasi Absen: ${attendance.location || 'Lokasi tidak diketahui'}</div>
            </div>
            <div class="signature">
              Kepala Sekolah.<br />
              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            </div>
          </div>
        </div>
      </body>
    </html>`;
  };

  const handlePrintRecord = (attendance) => {
    const template = buildPrintTemplate(attendance);
    setPrintPreview({ open: true, content: template });
  };

  const handleExecutePrint = () => {
    const frame = document.getElementById('attendance-print-frame');
    if (frame && frame.contentWindow) {
      frame.contentWindow.focus();
      frame.contentWindow.print();
    }
  };

  const handleConfirmDelete = (attendance) => {
    setDeleteConfirm({ open: true, attendance });
  };

  const handleOpenManualDialog = (prefill = null) => {
    setManualError('');
    setManualSearch('');
    setManualForm({
      employee_id: prefill?.personDbId ? String(prefill.personDbId) : '',
      date: prefill?.date || selectedDate || new Date().toISOString().split('T')[0],
      status: 'permission',
      notes: '',
    });
    setOpenManualDialog(true);
  };

  const handleCloseManualDialog = () => {
    if (manualSubmitting) return;
    setOpenManualDialog(false);
    setManualError('');
  };

  const handleSubmitManual = async () => {
    if (!manualForm.employee_id || !manualForm.date) {
      setManualError('Pilih siswa/guru dan tanggal terlebih dahulu');
      return;
    }
    setManualSubmitting(true);
    setManualError('');
    try {
      const token = localStorage.getItem('token');
      if (!token) throw new Error('Token autentikasi tidak ditemukan');

      await axios.post(`${API_URL}/api/attendance/manual`, {
        employee_id: Number(manualForm.employee_id),
        date: manualForm.date,
        status: manualForm.status,
        notes: manualForm.notes.trim() || null,
      }, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setOpenManualDialog(false);
      await loadAttendanceData();
    } catch (error) {
      const msg = error?.response?.data?.error || error?.message || 'Gagal menyimpan data';
      setManualError(msg);
    } finally {
      setManualSubmitting(false);
    }
  };

  const handleOpenStatusChangeDialog = (attendance) => {
    setStatusChangeDialog({
      open: true,
      attendance: attendance,
      newStatus: attendance.status
    });
    setStatusChangeError('');
  };

  const handleCloseStatusChangeDialog = () => {
    if (statusChangeLoading) return;
    setStatusChangeDialog({ open: false, attendance: null, newStatus: '' });
    setStatusChangeError('');
  };

  const handleStatusChangeConfirm = async () => {
    if (!statusChangeDialog.attendance || !statusChangeDialog.newStatus) return;

    setStatusChangeLoading(true);
    setStatusChangeError('');
    try {
      const token = localStorage.getItem('token');
      if (!token) throw new Error('Token autentikasi tidak ditemukan');

      const response = await axios.put(
        `${API_URL}/api/attendance/${statusChangeDialog.attendance.id}/status`,
        {
          status: statusChangeDialog.newStatus,
          notes: `Diubah manual oleh admin`
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setStatusChangeDialog({ open: false, attendance: null, newStatus: '' });
      await loadAttendanceData();
      
      console.log('✅ Status berhasil diubah:', response.data.changeLog);
    } catch (error) {
      const msg = error?.response?.data?.error || error?.message || 'Gagal mengubah status';
      setStatusChangeError(msg);
      console.error('❌ Error changing status:', error);
    } finally {
      setStatusChangeLoading(false);
    }
  };

   const handleDeleteAttendance = async () => {
     if (!deleteConfirm.attendance) return;
     
     try {
       setDeletingId(deleteConfirm.attendance.id);
       const token = localStorage.getItem('token');
       if (!token) throw new Error('Token autentikasi tidak ditemukan');

       await axios.delete(`${API_URL}/api/attendance/${deleteConfirm.attendance.id}`, {
         headers: { Authorization: `Bearer ${token}` },
       });

       setAttendanceData(prev => prev.filter(item => item.id !== deleteConfirm.attendance.id));
       await loadAttendanceData();
     } catch (error) {
       console.error('Error deleting attendance:', error);
       const serverMessage = error?.response?.data?.error || error?.response?.data?.message;
       alert(serverMessage ? `Gagal menghapus data absensi: ${serverMessage}` : 'Gagal menghapus data absensi');
     } finally {
       setDeletingId(null);
       setDeleteConfirm({ open: false, attendance: null });
     }
   };

   const handleOpenStatusModal = async (attendance) => {
     try {
       const token = localStorage.getItem('token');
       if (!token) {
         throw new Error('Token autentikasi tidak ditemukan');
       }

       // Fetch settings untuk default times
       const settingsResponse = await fetch(`${API_URL}/api/settings`, {
         headers: { 'Authorization': `Bearer ${token}` }
       });

       if (!settingsResponse.ok) {
         throw new Error('Gagal memuat pengaturan');
       }

       const settingsData = await settingsResponse.json();
       
       // Extract default times dari settings
       let defaultCheckIn = '07:00';
       let defaultCheckOut = '13:00';

       if (settingsData.data && settingsData.data.attendance) {
         const attendanceSettings = settingsData.data.attendance;
         const presentSetting = attendanceSettings.find(s => s.key === 'attendance_present_until');
         const checkoutSetting = attendanceSettings.find(s => s.key === 'attendance_regular_checkout_start');
         
         if (presentSetting) defaultCheckIn = presentSetting.value;
         if (checkoutSetting) defaultCheckOut = checkoutSetting.value;
       }

       // Format times dari attendance record jika ada
       let checkInTime = defaultCheckIn;
       let checkOutTime = defaultCheckOut;

       if (attendance?.check_in) {
         const checkInDate = new Date(attendance.check_in);
         checkInTime = checkInDate.toLocaleTimeString('id-ID', { hour: '2-digit', minute: '2-digit', hour12: false });
       }

        if (attendance?.check_out) {
          const checkOutDate = new Date(attendance.check_out);
          checkOutTime = checkOutDate.toLocaleTimeString('id-ID', { hour: '2-digit', minute: '2-digit', hour12: false });
        }

        // Handle placeholder/absent records
        // Absent records have id format: "absent-{person.id}-{dateKey}"
        const isPlaceholder = String(attendance.id).startsWith('absent-') || attendance.hasRecord === false;
        const employeeId = attendance.personDbId || attendance.employee_id;
        const attendanceId = !isPlaceholder ? attendance.id : null; // null untuk placeholder = CREATE mode

        if (!employeeId) {
          throw new Error('ID siswa/guru tidak valid');
        }

        setSelectedAttendanceForStatus({
          id: attendanceId,
          status: attendance?.status || 'present',
          checkInTime: checkInTime,
          checkOutTime: checkOutTime,
          name: attendance?.full_name || 'Siswa',
          employeeId: employeeId,
          defaultCheckIn,
          defaultCheckOut,
          isPlaceholder: isPlaceholder
        });
        setStatusModalOpen(true);
     } catch (error) {
       console.error('Error opening status modal:', error);
       alert(error.message || 'Gagal membuka form ubah status');
     }
   };

   const handleStatusChanged = (updatedRecord) => {
     setSuccessDialogOpen(true);
     loadAttendanceData();
   };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
        <CircularProgress size={60} />
      </Box>
    );
  }

  return (
    <Fade in={true} timeout={800}>
      <Box sx={{ p: { xs: 2, sm: 3, md: 4 } }}>
        {/* Header */}
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={4}>
          <Box>
            <Typography variant="h3" sx={{ fontWeight: 800, color: '#0f172a', mb: 1, fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' } }}>
              Data Absensi {isTeacherTab ? 'Guru' : 'Siswa'}
            </Typography>
            <Typography variant="h6" color="text.secondary" sx={{ fontWeight: 500, fontSize: { xs: '1rem', sm: '1.1rem', md: '1.25rem' } }}>
              {isTeacherTab
                ? 'Kehadiran guru via QR — tanpa notifikasi WhatsApp'
                : 'Monitor kehadiran siswa — data terbaru di atas'}
            </Typography>
            <ToggleButtonGroup
              value={personTab}
              exclusive
              onChange={(_, value) => value && setPersonTab(value)}
              sx={{ mt: 2 }}
              size="small"
            >
              <ToggleButton value="student">Siswa</ToggleButton>
              <ToggleButton value="teacher">Guru</ToggleButton>
            </ToggleButtonGroup>
          </Box>
          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
            <Button
              variant="contained"
              startIcon={<Add />}
              onClick={() => handleOpenManualDialog()}
              sx={{
                bgcolor: '#8b5cf6',
                '&:hover': { bgcolor: '#7c3aed' },
                borderRadius: 2,
                px: 3,
                py: 1.5,
              }}
            >
              Input Izin/Sakit
            </Button>
          </Box>
        </Box>

        {/* Stats Cards */}
        <Grid container spacing={3} sx={{ mb: 4 }}>
          <Grid item xs={6} sm={4} md={2}>
            <Card sx={{ 
              bgcolor: '#1976d2', 
              color: '#ffffff',
              borderRadius: 2,
              boxShadow: '0 4px 6px -1px rgba(25, 118, 210, 0.3)'
            }}>
              <CardContent sx={{ p: 3, textAlign: 'center' }}>
                <Typography variant="h4" sx={{ fontWeight: 800, mb: 1 }}>
                  {stats.total}
                </Typography>
                <Typography variant="body2" sx={{ opacity: 0.9 }}>
                  {isTeacherTab ? 'Total Guru' : 'Total Siswa'}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={6} sm={4} md={2}>
            <Card sx={{ 
              bgcolor: '#10b981', 
              color: '#ffffff',
              borderRadius: 2,
              boxShadow: '0 4px 6px -1px rgba(16, 185, 129, 0.3)'
            }}>
              <CardContent sx={{ p: 3, textAlign: 'center' }}>
                <Typography variant="h4" sx={{ fontWeight: 800, mb: 1 }}>
                  {stats.present}
                </Typography>
                <Typography variant="body2" sx={{ opacity: 0.9 }}>
                  Hadir
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={6} sm={4} md={2}>
            <Card sx={{ 
              bgcolor: '#f59e0b', 
              color: '#ffffff',
              borderRadius: 2,
              boxShadow: '0 4px 6px -1px rgba(245, 158, 11, 0.3)'
            }}>
              <CardContent sx={{ p: 3, textAlign: 'center' }}>
                <Typography variant="h4" sx={{ fontWeight: 800, mb: 1 }}>
                  {stats.late}
                </Typography>
                <Typography variant="body2" sx={{ opacity: 0.9 }}>
                  Terlambat
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={6} sm={4} md={2}>
            <Card sx={{ 
              bgcolor: '#3b82f6', 
              color: '#ffffff',
              borderRadius: 2,
              boxShadow: '0 4px 6px -1px rgba(59, 130, 246, 0.3)'
            }}>
              <CardContent sx={{ p: 3, textAlign: 'center' }}>
                <Typography variant="h4" sx={{ fontWeight: 800, mb: 1 }}>
                  {stats.sick}
                </Typography>
                <Typography variant="body2" sx={{ opacity: 0.9 }}>
                  Sakit
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={6} sm={4} md={2}>
            <Card sx={{ 
              bgcolor: '#8b5cf6', 
              color: '#ffffff',
              borderRadius: 2,
              boxShadow: '0 4px 6px -1px rgba(139, 92, 246, 0.3)'
            }}>
              <CardContent sx={{ p: 3, textAlign: 'center' }}>
                <Typography variant="h4" sx={{ fontWeight: 800, mb: 1 }}>
                  {stats.permission}
                </Typography>
                <Typography variant="body2" sx={{ opacity: 0.9 }}>
                  Izin
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={6} sm={4} md={2}>
            <Card sx={{ 
              bgcolor: '#ef4444', 
              color: '#ffffff',
              borderRadius: 2,
              boxShadow: '0 4px 6px -1px rgba(239, 68, 68, 0.3)'
            }}>
              <CardContent sx={{ p: 3, textAlign: 'center' }}>
                <Typography variant="h4" sx={{ fontWeight: 800, mb: 1 }}>
                  {stats.absent}
                </Typography>
                <Typography variant="body2" sx={{ opacity: 0.9 }}>
                  Alpha
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        {/* Filters and Search */}
        <Card sx={{ 
          border: 'none',
          borderRadius: 6,
          boxShadow: '0 8px 12px -1px rgba(0, 0, 0, 0.1), 0 4px 6px -1px rgba(0, 0, 0, 0.06)',
          mb: 4
        }}>
          <CardContent sx={{ p: 4 }}>
            <Grid container spacing={3} alignItems="center">
              <Grid item xs={12} md={2}>
                <FormControl fullWidth>
                  <InputLabel>Rentang</InputLabel>
                  <Select
                    value={filterRange}
                    label="Rentang"
                    onChange={(e) => setFilterRange(e.target.value)}
                    sx={{ borderRadius: 2 }}
                  >
                    <MenuItem value="date">Per Tanggal</MenuItem>
                    <MenuItem value="month">Per Bulan</MenuItem>
                    <MenuItem value="all">Semua Data</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              {filterRange === 'date' && (
                <Grid item xs={12} md={3}>
                  <TextField
                    fullWidth
                    type="date"
                    label="Filter Tanggal"
                    value={selectedDate}
                    onChange={(e) => setSelectedDate(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                    helperText={selectedDate ? `Rekap semua siswa pada ${new Date(selectedDate + 'T12:00:00').toLocaleDateString('id-ID')}` : 'Pilih tanggal untuk rekap harian per siswa'}
                    InputProps={{
                      endAdornment: selectedDate ? (
                        <InputAdornment position="end">
                          <IconButton size="small" onClick={() => setSelectedDate('')}>
                            <Close fontSize="small" />
                          </IconButton>
                        </InputAdornment>
                      ) : null,
                    }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 2,
                        '&:hover fieldset': { borderColor: '#1976d2' },
                        '&.Mui-focused fieldset': { borderColor: '#1976d2' },
                      },
                    }}
                  />
                </Grid>
              )}

              {filterRange === 'month' && (
                <Grid item xs={12} md={3}>
                  <TextField
                    fullWidth
                    type="month"
                    label="Filter Bulan"
                    value={selectedMonth}
                    onChange={(e) => setSelectedMonth(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                    helperText="Pilih bulan untuk menampilkan data"
                    InputProps={{
                      endAdornment: selectedMonth ? (
                        <InputAdornment position="end">
                          <IconButton size="small" onClick={() => setSelectedMonth('')}>
                            <Close fontSize="small" />
                          </IconButton>
                        </InputAdornment>
                      ) : null,
                    }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 2,
                        '&:hover fieldset': { borderColor: '#1976d2' },
                        '&.Mui-focused fieldset': { borderColor: '#1976d2' },
                      },
                    }}
                  />
                </Grid>
              )}

              <Grid item xs={12} md={filterRange === 'date' || filterRange === 'month' ? 3 : 4}>
                <TextField
                  fullWidth
                  placeholder={isTeacherTab ? 'Cari nama atau NIP guru...' : 'Cari nama atau NIS siswa...'}
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Search sx={{ color: '#64748b' }} />
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 2,
                      bgcolor: '#ffffff',
                      '&:hover fieldset': { borderColor: '#1976d2' },
                      '&.Mui-focused fieldset': { borderColor: '#1976d2' },
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <FormControl fullWidth>
                  <InputLabel>Status</InputLabel>
                  <Select
                    value={filterStatus}
                    onChange={(e) => setFilterStatus(e.target.value)}
                    label="Status"
                    sx={{ borderRadius: 2 }}
                  >
                    <MenuItem value="all">Semua Status</MenuItem>
                    <MenuItem value="present">Hadir</MenuItem>
                    <MenuItem value="late">Terlambat</MenuItem>
                    <MenuItem value="sick">Sakit</MenuItem>
                    <MenuItem value="permission">Izin</MenuItem>
                    <MenuItem value="absent">Alpha</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              {!isTeacherTab && (
                <Grid item xs={12} md={2}>
                  <FormControl fullWidth>
                    <InputLabel>Kelas</InputLabel>
                    <Select
                      value={filterGrade}
                      onChange={(e) => setFilterGrade(e.target.value)}
                      label="Kelas"
                      sx={{ borderRadius: 2 }}
                    >
                      <MenuItem value="all">Semua Kelas</MenuItem>
                      {grades.map((grade) => (
                        <MenuItem key={grade} value={grade.toString()}>Kelas {grade}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              )}
              <Grid item xs={12} md={2}>
                <Button
                  variant="outlined"
                  startIcon={<FilterList />}
                  fullWidth
                  onClick={() => {
                    setPage(0);
                    loadAttendanceData();
                  }}
                  disabled={loading}
                  sx={{
                    borderColor: '#e2e8f0',
                    color: '#64748b',
                    '&:hover': { 
                      borderColor: '#cbd5e1',
                      bgcolor: '#f8fafc'
                    },
                    borderRadius: 2,
                    py: 1.5,
                  }}
                >
                  {loading ? 'Memuat...' : 'Terapkan'}
                </Button>
              </Grid>
            </Grid>
          </CardContent>
        </Card>

        {/* Attendance Table */}
        <Card sx={{ 
          border: 'none',
          borderRadius: 6,
          boxShadow: '0 8px 12px -1px rgba(0, 0, 0, 0.1), 0 4px 6px -1px rgba(0, 0, 0, 0.06)',
        }}>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow sx={{ bgcolor: '#f8fafc' }}>
                  <TableCell sx={{ fontWeight: 600, color: '#0f172a' }}>{isTeacherTab ? 'Guru' : 'Siswa'}</TableCell>
                  <TableCell sx={{ fontWeight: 600, color: '#0f172a' }}>{isTeacherTab ? 'Unit' : 'Kelas'}</TableCell>
                  <TableCell sx={{ fontWeight: 600, color: '#0f172a' }}>Check In</TableCell>
                  <TableCell sx={{ fontWeight: 600, color: '#0f172a' }}>Check Out</TableCell>
                  <TableCell sx={{ fontWeight: 600, color: '#0f172a' }}>Total Jam</TableCell>
                  <TableCell sx={{ fontWeight: 600, color: '#0f172a' }}>Status</TableCell>
                  <TableCell sx={{ fontWeight: 600, color: '#0f172a' }}>Aksi</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredAttendance.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={7} align="center" sx={{ py: 8 }}>
                      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, opacity: 0.6 }}>
                        <Description sx={{ fontSize: 48 }} />
                        <Typography variant="h6">Tidak ada data absensi</Typography>
                        <Typography variant="body2">
                          {filterRange === 'all' 
                            ? 'Belum ada catatan absensi sama sekali di sistem.' 
                            : `Tidak ada data absensi untuk ${filterRange === 'date' ? 'tanggal' : 'bulan'} yang dipilih.`}
                        </Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                ) : (
                  filteredAttendance
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((attendance) => (
                    <TableRow key={attendance.id} hover>
                      <TableCell>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                          <Avatar sx={{ 
                            bgcolor: '#1976d2',
                            width: 40,
                            height: 40,
                            fontSize: '1rem',
                            fontWeight: 600
                          }}>
                            {attendance.avatar}
                          </Avatar>
                          <Box>
                            <Typography variant="body1" sx={{ fontWeight: 600, color: '#0f172a' }}>
                              {attendance.name}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              {isTeacherTab ? 'NIP' : 'NIS'}: {attendance.studentId}
                            </Typography>
                          </Box>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Chip 
                          label={
                            isTeacherTab
                              ? (attendance.classroom || 'Guru')
                              : (attendance.grade ? `Kelas ${attendance.grade}${attendance.classroom || ''}` : '-')
                          }
                          size="small"
                          sx={{ 
                            bgcolor: '#f1f5f9',
                            color: '#0f172a',
                            fontWeight: 500
                          }}
                        />
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2" sx={{ 
                          fontWeight: 500,
                          color: attendance.isManual ? '#64748b' : (attendance.checkIn ? '#0f172a' : '#ef4444')
                        }}>
                          {attendance.isManual
                            ? '—'
                            : attendance.checkIn
                              ? new Date(attendance.checkIn).toLocaleTimeString('id-ID', { hour: '2-digit', minute: '2-digit' })
                              : '—'}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2" sx={{ 
                          fontWeight: 500,
                          color: attendance.isManual ? '#64748b' : (attendance.checkOut ? '#0f172a' : attendance.status === 'absent' ? '#ef4444' : '#f59e0b')
                        }}>
                          {attendance.isManual
                            ? '—'
                            : attendance.checkOut
                              ? new Date(attendance.checkOut).toLocaleTimeString('id-ID', { hour: '2-digit', minute: '2-digit' })
                              : attendance.status === 'absent' ? '—' : 'Belum pulang'}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                          {formatDuration(attendance.totalDurationSeconds)}
                        </Typography>
                        {attendance.overtime > 0 && (
                          <Typography variant="caption" sx={{ color: '#f59e0b', fontWeight: 500 }}>
                            +{attendance.overtime} jam OT
                          </Typography>
                        )}
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                          <Chip 
                            icon={getStatusIcon(attendance.status)}
                            label={getStatusLabel(attendance.status)} 
                            size="small"
                            sx={{ 
                              bgcolor: getStatusColor(attendance.status),
                              color: '#ffffff',
                              fontWeight: 500
                            }}
                          />
                          <Tooltip title="Ubah Status">
                            <IconButton
                              size="small"
                              onClick={() => handleOpenStatusModal(attendance)}
                              sx={{ 
                                color: '#1976d2',
                                '&:hover': { bgcolor: '#e3f2fd' }
                              }}
                            >
                              <EventNote fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Tooltip title="Lihat Detail">
                          <IconButton
                            size="small"
                            onClick={() => handleOpenDetails(attendance)}
                            sx={{ 
                              color: '#1976d2',
                              '&:hover': { bgcolor: '#e3f2fd' }
                            }}
                          >
                            <Person fontSize="small" />
                          </IconButton>
                        </Tooltip>
                        {attendance.status === 'absent' && filterRange === 'date' && (
                          <Tooltip title="Catat Izin/Sakit">
                            <IconButton
                              size="small"
                              onClick={() => handleOpenManualDialog(attendance)}
                              sx={{ 
                                color: '#8b5cf6',
                                '&:hover': { bgcolor: '#ede9fe' }
                              }}
                            >
                              <EventNote fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        )}
                        {!attendance.isManual && (
                          <Tooltip title="Print Absensi">
                            <IconButton
                              size="small"
                              onClick={() => handlePrintRecord(attendance)}
                              sx={{ 
                                color: '#1976d2',
                                '&:hover': { bgcolor: '#e3f2fd' }
                              }}
                            >
                              <Print fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        )}
                        <Tooltip title="Hapus Absensi">
                          <span>
                            <IconButton
                              size="small"
                            onClick={() => handleConfirmDelete(attendance)}
                              disabled={deletingId === attendance.id || String(attendance.id).startsWith('absent-')}
                              sx={{ 
                                color: '#dc2626',
                                '&:hover': { bgcolor: '#fee2e2' }
                              }}
                            >
                              <Delete fontSize="small" />
                            </IconButton>
                          </span>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 50, 100]}
            component="div"
            count={filteredAttendance.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            labelRowsPerPage="Baris per halaman"
          />
        </Card>

        {/* Attendance Details Dialog */}
        <Dialog open={openDetailsDialog} onClose={handleCloseDetails} maxWidth="md" fullWidth>
          <DialogTitle sx={{ pb: 1 }}>
            Detail Absensi - {selectedAttendance?.name}
          </DialogTitle>
          <DialogContent sx={{ pt: 2 }}>
            {selectedAttendance && (
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                    NIS
                  </Typography>
                  <Typography variant="body1" sx={{ fontWeight: 500 }}>
                    {selectedAttendance.studentId}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                    Kelas
                  </Typography>
                  <Typography variant="body1" sx={{ fontWeight: 500 }}>
                    {`Kelas ${selectedAttendance.grade}${selectedAttendance.classroom}`}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                    Tanggal
                  </Typography>
                  <Typography variant="body1" sx={{ fontWeight: 500 }}>
                    {new Date(selectedAttendance.date).toLocaleDateString('id-ID', {
                      weekday: 'long',
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric'
                    })}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                    Status
                  </Typography>
                  <Chip 
                    icon={getStatusIcon(selectedAttendance.status)}
                    label={getStatusLabel(selectedAttendance.status)} 
                    size="small"
                    sx={{ 
                      bgcolor: getStatusColor(selectedAttendance.status),
                      color: '#ffffff',
                      fontWeight: 500
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                    Check In
                  </Typography>
                  <Typography variant="body1" sx={{ fontWeight: 500 }}>
                    {selectedAttendance.isManual
                      ? 'Input manual (tanpa scan)'
                      : (selectedAttendance.checkIn || 'Tidak Hadir')}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                    Check Out
                  </Typography>
                  <Typography variant="body1" sx={{ fontWeight: 500 }}>
                    {selectedAttendance.isManual
                      ? '—'
                      : (selectedAttendance.checkOut || 'Tidak Hadir')}
                  </Typography>
                </Grid>
                {selectedAttendance.notes && (
                  <Grid item xs={12}>
                    <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                      Keterangan
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      {selectedAttendance.notes}
                    </Typography>
                  </Grid>
                )}
                <Grid item xs={12} sm={6}>
                  <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                    Total Jam Kerja
                  </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      {formatDuration(selectedAttendance.totalDurationSeconds)}
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                    Lembur
                  </Typography>
                  <Typography variant="body1" sx={{ fontWeight: 500 }}>
                    {selectedAttendance.overtime > 0 ? `${selectedAttendance.overtime} jam` : 'Tidak ada'}
                  </Typography>
                </Grid>
              </Grid>
            )}
          </DialogContent>
          <DialogActions sx={{ p: 3, pt: 1 }}>
            <Button onClick={handleCloseDetails} sx={{ color: '#64748b' }}>
              Tutup
            </Button>
          </DialogActions>
        </Dialog>

        {/* Manual Izin/Sakit Dialog */}
        <Dialog open={openManualDialog} onClose={handleCloseManualDialog} maxWidth="sm" fullWidth>
          <DialogTitle sx={{ pb: 1 }}>
            Input Izin / Sakit
          </DialogTitle>
          <DialogContent sx={{ pt: 2 }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                {/* Search Field + Autocomplete */}
                <TextField
                  fullWidth
                  label={isTeacherTab ? 'Cari Nama Guru' : 'Cari Nama Siswa / Kelas'}
                  placeholder="Ketik nama atau kelas (misal: Andi / Kelas 1A)"
                  value={manualSearch}
                  onChange={(e) => setManualSearch(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  sx={{ mt: 1 }}
                />
                {/* Filtered Results */}
                <Box sx={{ maxHeight: 200, overflow: 'auto', mt: 2, border: '1px solid #e0e0e0', borderRadius: 1 }}>
                  {[...peopleList]
                    .sort((a, b) => (a.full_name || '').localeCompare(b.full_name || '', 'id'))
                    .filter((person) => {
                      const search = manualSearch.toLowerCase().trim();
                      if (!search) return true;
                      const name = (person.full_name || '').toLowerCase();
                      const gradeClass = !isTeacherTab && person.grade 
                        ? `kelas ${person.grade}${(person.classroom || '').toLowerCase()}` 
                        : '';
                      const studentId = (person.student_id || '').toLowerCase();
                      return name.includes(search) || gradeClass.includes(search) || studentId.includes(search);
                    })
                    .map((person) => {
                      const isSelected = String(person.id) === String(manualForm.employee_id);
                      return (
                        <Box
                          key={person.id}
                          onClick={() => setManualForm((prev) => ({ ...prev, employee_id: String(person.id) }))}
                          sx={{
                            p: 1.5,
                            cursor: 'pointer',
                            bgcolor: isSelected ? '#ede9fe' : 'transparent',
                            '&:hover': { bgcolor: isSelected ? '#ede9fe' : '#f5f5f5' },
                            borderBottom: '1px solid #e0e0e0',
                          }}
                        >
                          <Typography variant="body1" sx={{ fontWeight: isSelected ? 600 : 400 }}>
                            {person.full_name}
                          </Typography>
                          <Typography variant="caption" color="text.secondary">
                            {!isTeacherTab && person.grade 
                              ? `Kelas ${person.grade}${person.classroom || ''}` 
                              : 'Guru'}
                            {person.student_id ? ` • ${person.student_id}` : ''}
                          </Typography>
                        </Box>
                      );
                    })}
                </Box>
                {manualForm.employee_id && (
                  <Typography variant="caption" color="success.main" sx={{ mt: 1, display: 'block' }}>
                    ✓ Siswa/Guru dipilih
                  </Typography>
                )}
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  type="date"
                  label="Tanggal"
                  value={manualForm.date}
                  onChange={(e) => setManualForm((prev) => ({ ...prev, date: e.target.value }))}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <InputLabel>Status</InputLabel>
                  <Select
                    value={manualForm.status}
                    label="Status"
                    onChange={(e) => setManualForm((prev) => ({ ...prev, status: e.target.value }))}
                  >
                    <MenuItem value="permission">Izin</MenuItem>
                    <MenuItem value="sick">Sakit</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  multiline
                  minRows={2}
                  label="Keterangan (opsional)"
                  placeholder="Contoh: Surat izin dari orang tua"
                  value={manualForm.notes}
                  onChange={(e) => setManualForm((prev) => ({ ...prev, notes: e.target.value }))}
                />
              </Grid>
              {manualError && (
                <Grid item xs={12}>
                  <Typography variant="body2" color="error.main">
                    {manualError}
                  </Typography>
                </Grid>
              )}
            </Grid>
          </DialogContent>
          <DialogActions sx={{ p: 3, pt: 1 }}>
            <Button onClick={handleCloseManualDialog} disabled={manualSubmitting}>
              Batal
            </Button>
            <Button
              variant="contained"
              onClick={handleSubmitManual}
              disabled={manualSubmitting}
              sx={{ bgcolor: '#8b5cf6', '&:hover': { bgcolor: '#7c3aed' } }}
            >
              {manualSubmitting ? 'Menyimpan...' : 'Simpan'}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Status Change Dialog */}
        <Dialog open={statusChangeDialog.open} onClose={handleCloseStatusChangeDialog} maxWidth="sm" fullWidth>
          <DialogTitle sx={{ pb: 1 }}>
            Ubah Status Absensi
          </DialogTitle>
          <DialogContent sx={{ pt: 2 }}>
            {statusChangeDialog.attendance && (
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography variant="subtitle2" color="text.secondary">
                    Nama Siswa/Guru
                  </Typography>
                  <Typography variant="body1" sx={{ fontWeight: 600 }}>
                    {statusChangeDialog.attendance.full_name}
                  </Typography>
                </Grid>
                
                <Grid item xs={6}>
                  <Typography variant="subtitle2" color="text.secondary">
                    Status Saat Ini
                  </Typography>
                  <Chip 
                    label={getStatusLabel(statusChangeDialog.attendance.status)} 
                    size="small"
                    sx={{ 
                      bgcolor: getStatusColor(statusChangeDialog.attendance.status),
                      color: '#ffffff',
                      fontWeight: 500,
                      mt: 0.5
                    }}
                  />
                </Grid>

                <Grid item xs={6}>
                  <Typography variant="subtitle2" color="text.secondary">
                    Status Baru
                  </Typography>
                  <Chip 
                    label={getStatusLabel(statusChangeDialog.newStatus)} 
                    size="small"
                    sx={{ 
                      bgcolor: getStatusColor(statusChangeDialog.newStatus),
                      color: '#ffffff',
                      fontWeight: 500,
                      mt: 0.5
                    }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <InputLabel>Pilih Status Baru</InputLabel>
                    <Select
                      value={statusChangeDialog.newStatus}
                      label="Pilih Status Baru"
                      onChange={(e) => setStatusChangeDialog((prev) => ({ ...prev, newStatus: e.target.value }))}
                    >
                      <MenuItem value="present">Hadir</MenuItem>
                      <MenuItem value="late">Terlambat</MenuItem>
                      <MenuItem value="sick">Sakit</MenuItem>
                      <MenuItem value="permission">Izin</MenuItem>
                      <MenuItem value="absent">Alpa</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                {statusChangeError && (
                  <Grid item xs={12}>
                    <Typography variant="body2" color="error.main">
                      {statusChangeError}
                    </Typography>
                  </Grid>
                )}
              </Grid>
            )}
          </DialogContent>
          <DialogActions sx={{ p: 3, pt: 1 }}>
            <Button onClick={handleCloseStatusChangeDialog} disabled={statusChangeLoading}>
              Batal
            </Button>
            <Button
              variant="contained"
              onClick={handleStatusChangeConfirm}
              disabled={statusChangeLoading}
              sx={{ bgcolor: '#1976d2', '&:hover': { bgcolor: '#1565c0' } }}
            >
              {statusChangeLoading ? 'Menyimpan...' : 'Ubah Status'}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Print Preview Dialog */}
        <Dialog
          open={printPreview.open}
          onClose={() => setPrintPreview({ open: false, content: '' })}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle>Print Absensi</DialogTitle>
          <DialogContent dividers sx={{ height: 600, bgcolor: '#edf2ff' }}>
            {printPreview.content && (
              <iframe
                id="attendance-print-frame"
                title="print-preview"
                srcDoc={printPreview.content}
                style={{ width: '100%', height: '100%', border: 'none', borderRadius: 12 }}
              />
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setPrintPreview({ open: false, content: '' })} sx={{ color: '#64748b' }}>
              Tutup
            </Button>
            <Button onClick={handleExecutePrint} variant="contained" sx={{ bgcolor: '#1976d2', '&:hover': { bgcolor: '#1565c0' } }}>
              Cetak
            </Button>
          </DialogActions>
        </Dialog>

        {/* Delete Confirmation Dialog */}
        <Dialog
          open={deleteConfirm.open}
          onClose={() => setDeleteConfirm({ open: false, attendance: null })}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle>Hapus Data Absensi</DialogTitle>
          <DialogContent dividers>
            <Typography>
              Apakah Anda yakin ingin menghapus absensi{' '}
              <strong>{deleteConfirm.attendance?.name}</strong>?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setDeleteConfirm({ open: false, attendance: null })} sx={{ color: '#64748b' }}>
              Batal
            </Button>
            <Button
              onClick={handleDeleteAttendance}
              variant="contained"
              sx={{ bgcolor: '#dc2626', '&:hover': { bgcolor: '#b91c1c' } }}
              disabled={deletingId === deleteConfirm.attendance?.id}
            >
              {deletingId === deleteConfirm.attendance?.id ? 'Menghapus...' : 'Hapus'}
            </Button>
          </DialogActions>
         </Dialog>

         {/* Status Change Modal */}
         <StatusChangeModal
           isOpen={statusModalOpen}
           onClose={() => setStatusModalOpen(false)}
           attendanceId={selectedAttendanceForStatus?.id}
           currentStatus={selectedAttendanceForStatus?.status}
           studentName={selectedAttendanceForStatus?.name}
           employeeId={selectedAttendanceForStatus?.employeeId}
           defaultCheckInTime={selectedAttendanceForStatus?.defaultCheckIn}
           defaultCheckOutTime={selectedAttendanceForStatus?.defaultCheckOut}
           onStatusChanged={handleStatusChanged}
         />

         {/* Success Dialog - Centered Popup */}
         <Dialog
           open={successDialogOpen}
           onClose={() => setSuccessDialogOpen(false)}
           maxWidth="xs"
           fullWidth
           PaperProps={{
             sx: {
               borderRadius: 2,
               textAlign: 'center',
               p: 2
             }
           }}
         >
           <DialogContent sx={{ pt: 3, pb: 2 }}>
             <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
               <CheckCircle sx={{ fontSize: 60, color: '#4caf50' }} />
             </Box>
             <Typography variant="h6" sx={{ fontWeight: 600, color: '#0f172a', mb: 1 }}>
               Status Berhasil Diubah
             </Typography>
             <Typography variant="body2" sx={{ color: '#64748b' }}>
               Data absensi telah diperbarui
             </Typography>
           </DialogContent>
           <DialogActions sx={{ justifyContent: 'center', pb: 2 }}>
             <Button
               onClick={() => setSuccessDialogOpen(false)}
               variant="contained"
               sx={{ bgcolor: '#4caf50', '&:hover': { bgcolor: '#45a049' } }}
             >
               OK
             </Button>
           </DialogActions>
         </Dialog>
        </Box>
    </Fade>
  );
};

export default Attendance;
